import { baseApi } from 'app/baseApi';
import { baseQuery } from 'app/baseQuery';
import { apiTags } from 'app/store/apiTags';

const apiPrefix = 'customFormResponse';
export const customFormResponseApi = baseApi.injectEndpoints({
    reducerPath: 'customFormResponseApi',
    tagTypes: [apiTags.CUSTOM_FORM_RESPONSE],
    baseQuery: baseQuery,
    endpoints: (builder) => ({
        getCustomFormResponse: builder.query({
            query: ({ vehicleId, formType, workOrderId, includeImages, activityItemId }) => `${apiPrefix}/?vehicleId=${vehicleId}&formType=${formType}&workOrderId=${workOrderId}&includeImages=${includeImages}&activityItemId=${activityItemId}`,
            providesTags: [apiTags.CUSTOM_FORM_RESPONSE, apiTags.VEHICLE, apiTags.VEHICLES]
        }),
        updateFormResponse: builder.mutation({
            query: ({ id, clientAccountId, formId, lotId, vehicleId, answers, workOrderId, activityId }) => ({
                url: `${apiPrefix}`,
                method: "POST",
                body: {
                    id,
                    clientAccountId,
                    formId,
                    lotId,
                    vehicleId,
                    answers,
                    workOrderId,
                    activityId
                }
            }),
            invalidatesTags: [apiTags.CUSTOM_FORM_RESPONSE, apiTags.VEHICLE, apiTags.VEHICLES]
        }),
        resolveFormResponse: builder.mutation({
            query: (body) => ({
                url: `${apiPrefix}/resolve`,
                method: "POST",
                body
            }),
            invalidatesTags: [apiTags.CUSTOM_FORM_RESPONSE, apiTags.VEHICLE, apiTags.VEHICLES]
        }),
    }),
});

export const {
    useGetCustomFormResponseQuery,
    useUpdateFormResponseMutation,
    useResolveFormResponseMutation,
} = customFormResponseApi;
